import React, { InputHTMLAttributes } from 'react';
import { PasswordTextInput as PasswordTextInputCommon } from '@workday/upc-common';
import { ID_SHOW_PASSWORD_ICON } from '../../autoIds';
import { useTranslation } from 'react-i18next';
import { TextInputProps } from '@workday/canvas-kit-react/text-input';

type PasswordTextInputProps = TextInputProps &
    Pick<
        InputHTMLAttributes<HTMLInputElement>,
        | 'autoFocus'
        | 'autoComplete'
        | 'id'
        | 'className'
        | 'disabled'
        | 'onChange'
        | 'onBlur'
        | 'onFocus'
        | 'placeholder'
    >;

export const PasswordTextInput = React.forwardRef<HTMLInputElement, PasswordTextInputProps>((props, ref) => {
    const { t } = useTranslation('shared');

    return (
        <PasswordTextInputCommon
            {...props}
            showPasswordText={t('PasswordInput.showPassword')}
            showPasswordtestId={ID_SHOW_PASSWORD_ICON}
            ref={ref}
        />
    );
});
